import purchaseReceive from './index.js';

const RESET_STATE = state => {
  Object.assign(state, purchaseReceive.getDefaultState());
};

const SET_PURCHASE_RECEIVE_PROPERTY = (state, {propName, propVal})=>{
  state.purchaseReceive[propName]=propVal;
}

const SET_ITEMS = (state, items)=>{
  state.purchaseReceive.items = items;
}

const SET_ITEM_PRICE = (state, {index, price})=>{
  state.purchaseReceive.items[index].price = price;
}

const SET_LINE_PROPERTY = (state,{index, propName, propVal})=>{
    state.purchaseReceive.items[index][propName]=propVal;
};


const SET_LOADING = (state, loading)=>{
  state.loading = loading;
}

const SET_PURCHASE_RECEIVE_STATUS = (state, purchaseReceiveStatus)=>{
  state.purchaseReceiveStatus = purchaseReceiveStatus;
}

const SET_MAXIMUM_ITEM_PRICE_VARIATION = (state, maximumItemPriceVariation)=>{
  state.maximumItemPriceVariation=maximumItemPriceVariation;
}
const SET_MINIMUM_ITEM_PRICE_VARIATION = (state, minimumItemPriceVariation)=>{
  state.minimumItemPriceVariation=minimumItemPriceVariation;
}

const SET_INVENTORY_LIMIT = (state, limit) => {
  state.inventory_limit = limit;
}

const SET_INVENTORY = (state, inventory) => {
  state.inventory = inventory;
}

const SET_LINE_PROP_ERROR = (state, {prop, value, index}) => {
  if (prop === 'reference') {
    state.purchaseReceive.items[index].referenceError = value;
  }
}

export default {
  SET_LINE_PROP_ERROR,
  RESET_STATE,
  SET_PURCHASE_RECEIVE_PROPERTY,
  SET_ITEMS,
  SET_LINE_PROPERTY,
  SET_LOADING,
  SET_PURCHASE_RECEIVE_STATUS,
  SET_MINIMUM_ITEM_PRICE_VARIATION,
  SET_MAXIMUM_ITEM_PRICE_VARIATION,
  SET_INVENTORY_LIMIT,
  SET_INVENTORY
};
